import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c3b21366"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dropdown"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_search = _resolveComponent("van-search");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_search, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.value = $event),
    placeholder: '请输入' + $props.title,
    onInput: $options.showList,
    onClear: $options.clearValue
  }, null, 8, ["modelValue", "placeholder", "onInput", "onClear"]), _createElementVNode("div", {
    class: _normalizeClass({
      'dropdown-content': true,
      'dropdown-content-active': $data.isActive
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("a", {
      key: item.id,
      onClick: _withModifiers($event => $options.selectDropdownItem(item), ["prevent"])
    }, _toDisplayString(item.value), 9, _hoisted_2);
  }), 128))], 2)]);
}